'use strict';

import { action, observable, flow, makeObservable } from "mobx";
import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import appStore from "@uw-it-sis/lib-react/lib/AppStore";

import api from "../lib/Api";

class PrintViewStore {
    state = States.initial;

    constructor() {
        makeObservable(this, {
            state: observable,
            mount: action
        });

        this.planData = [];
        this.exceptionUtils = appStore.getExceptionUtils();
        this.httpClient = appStore.getHttpClient();
    }

    mount() {
        this._loadData();
    }

    _loadData = flow(function* () {
        this.state = States.pending;

        try {
            this.planData = yield api.getAllTerms();

            if (appStore.isDevMode()) {
                console.log('PrintViewStore: Data load complete');
            }

            this.state = States.done;
        } catch(error) {
            this.exceptionUtils.handleException(error, "PrintViewStore.loadData");
            this.state = States.error;
        }
    }.bind(this));

    getPlanData() {
        return this.planData;
    }
}

export default new PrintViewStore();